module.exports = __webpack_public_path__ + "static/media/29ADMSPC9.0975b6a9.jpg";